import { render, staticRenderFns } from "./institutionAvailabilitiesListItem.vue?vue&type=template&id=2949b2f2"
import script from "./institutionAvailabilitiesListItem.vue?vue&type=script&lang=ts"
export * from "./institutionAvailabilitiesListItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports